import type { WorldRoomDirectory } from "@cleo/contracts";

import { projectWorldSessionLineage } from "./worldView";

/**
 * The address arc (RAIL-5b, principal-ruled 2026-08-26): `?a=` on the slice
 * route names the ADDRESSED session — the one whose voice is fronted and
 * whose boundary the context rail shows — while the route's `$sessionId` stays
 * the staircase leaf. The address is view state: one selection, derived, no
 * second store (TB29/PR22).
 *
 * A valid address belongs to the same root-session tree. Folded children
 * remain addressable after their panel leaves the canvas lineage. Another
 * root, an unknown session or a closed session cannot change this room's voice.
 */
export function resolveAddressSessionId(
  index: WorldRoomDirectory,
  leafSessionId: string,
  requested: string | undefined,
): string {
  if (requested === undefined || requested === leafSessionId) return leafSessionId;
  const lineage = projectWorldSessionLineage(index, leafSessionId);
  const requestedLineage = projectWorldSessionLineage(index, requested);
  const target = requestedLineage.at(-1);
  return lineage.length > 0 &&
    target?.sessionId === requested &&
    target.engagement !== "headless" &&
    requestedLineage[0]?.sessionId === lineage[0]?.sessionId
    ? requested
    : leafSessionId;
}
